import { decodeJWTPayloadWithoutValidation } from './JWTUtils';

interface LicenseInfoResponse {
  date: string;
  result: string;
  license_id: string;
  license_model: string;
  features: Array<string>;
  feature_properties: Record<string, Record<string, unknown>>;
}

export async function getLicenseInfo(accessToken: string, appKey: string): Promise<LicenseInfoResponse | undefined> {
    const response = await fetch(
        `https://login.pcon-solutions.com/api/v1/license/info/${appKey}`,
        {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        }
    );
    return decodeJWTPayloadWithoutValidation(await response.text());
}